package com.devi3east.bashbuddy.supabase

import Config
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.Auth
import io.github.jan.supabase.createSupabaseClient
import io.github.jan.supabase.postgrest.Postgrest
import io.github.jan.supabase.storage.Storage

object SupabaseClient {

    private var _client: SupabaseClient? = null

    val client: SupabaseClient
        get() = _client
            ?: error("SupabaseClient not initialized. Call initialize() from platform entry.")

    fun initialize() {

        if (_client != null) {
            return
        }

        val url = if (Config.isProduction) "https://ghozvavjmdlrdyakqzwj.supabase.co" else "https://nwhvlynyotyeacbhonwu.supabase.co"
        val key = if (Config.isProduction) "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdob3p2YXZqbWRscmR5YWtxendqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg2Njk3NjAsImV4cCI6MjA2NDI0NTc2MH0.eKZYHyxQmQTLuGq43UAhDINxrP6CDbjyNYsdq0WRGY4" else "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im53aHZseW55b3R5ZWFjYmhvbnd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM5ODE2NTIsImV4cCI6MjA3OTU1NzY1Mn0.DTnpVq5NfvkKTp2hUZLZ4cYEL7gxfGithWB18pCf6jA"

        _client = createSupabaseClient(
            supabaseUrl = url,
            supabaseKey = key
        ) {
            install(Auth)
            install(Postgrest)
            install(Storage)
        }
    }

}